import { NetflixPosterInfo } from "../WeddingInfo/WeddingInfo";

interface NetflixRepresentProps {
  poster: NetflixPosterInfo;
}

const NetflixRepresentScreen: React.FC<NetflixRepresentProps> = ({
  poster,
}) => {
  return (
    <div className="flex flex-col mx-4 mt-4 text-left mb-8 ">
      <div className="relative">
        <img
          src={poster.image}
          alt={`Thumbnail`}
          className="w-full h-112 object-cover rounded-lg mb-1 border-[0.5px] border-gray-500"
        />

        {/* 하단 정보 박스 */}
        <div className="absolute bottom-0 h-80 bg-gradient-to-t from-black/90 to-transparent text-center w-full flex flex-col justify-end pb-4">
          <div
            className="text-white font-medium"
            style={{ fontSize: "clamp(1.5rem, 4vw, 2.2rem)" }}
          >
            {poster.title}
          </div>
          <div className="text-white text-xl mt-2">{poster.caption}</div>

          {/* 버튼 그룹 */}
          <div className="flex space-x-4 mt-4 w-full px-4">
            {/* ▶️ 재생 버튼 */}
            <button className="w-1/2 bg-white text-black font-bold px-4 py-2 rounded-md text-sm">
              ▶ 재생
            </button>

            {/* ❤️ 찜하기 버튼 */}
            <button className="w-1/2 bg-gray-300/10 text-white font-medium px-4 py-2 rounded-md text-sm">
              ✚ 내가 찜한 리스트
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetflixRepresentScreen;
